import React, { useState } from 'react'

const FORM_I18N = {
  da: {
    successTitle: 'Tusind tak for din forespørgsel!',
    successDesc:
      'Vi gennemgår dine ønsker og vender tilbage inden for 24 timer på hverdage med information og forslag til din kage.',
    newInquiry: 'Send en ny forespørgsel',
    cakeTypeLabel: 'Hvilken slags kage taler vi om?',
    types: {
      wedding: 'Bryllupskage',
      confirmation: 'Konfirmationskage',
      birthday: 'Fødselsdagskage',
      christening: 'Dåbskage',
      company: 'Firmakage',
      other: 'Anden festkage',
    },
    dateLabel: 'Dato for begivenhed',
    nameLabel: 'Dit navn',
    companyLabel: 'Evt. firmanavn',
    optional: 'valgfrit',
    emailLabel: 'E-mailadresse',
    mobileLabel: 'Mobilnummer',
    addressLabel: 'Adresse',
    postalLabel: 'Postnummer',
    cityLabel: 'By',
    countryLabel: 'Land',
    portionsLabel: 'Antal kuverter / personer',
    spongeLabel: 'Ønsket kagebund',
    sponges: [
      'Ikke besluttet endnu',
      'Klassisk lys vaniljebund',
      'Svampet chokoladebund',
      'Nøddebund / Mandelbund',
      'Gulerodsbund',
      'Browniebund',
      'Andet (angives i besked)',
    ],
    mousseLabel: 'Ønsket mousse / fyld',
    mousses: [
      'Ikke besluttet endnu',
      'Hvid chokolademousse med passionsfrugt',
      'Mørk chokolademousse med hindbær',
      'Mælkechokolademousse med saltkaramel',
      'Jordbærmousse / skovbær',
      'Citron- & limecreme',
      'Mocca- & karamelmousse',
      'Andet (angives i besked)',
    ],
    extraFillingLabel: 'Evt. ekstra fyld (crunch, bærkompot etc.)',
    extraDecoLabel: 'Ønsket dekoration / tema (friske blomster, bær, chokoladepynt)',
    cakeTextLabel: 'Evt. tekst på kagen',
    messageLabel: 'Beskrivelse af dine ønsker & særlige hensyn (allergier osv.)',
    messagePlaceholder:
      'Fortæl gerne om farver, stil, tema, levering eller afhentning på Fanø...',
    submitBtn: 'Send forespørgsel',
    submittingBtn: 'Sender forespørgsel...',
    requiredErr: 'Udfyld venligst navn og e-mailadresse.',
    genericErr: 'Der skete en fejl under afsendelsen. Prøv venligst igen.',
    privacyNote:
      'Dine personlige data vil hjælpe os når vi skal kontakte dig. Vi lover at passe på dine data og holde dem sikret.',
  },
  en: {
    successTitle: 'Thank you for your inquiry!',
    successDesc:
      'We will review your wishes and get back to you within 24 hours on business days with details and recommendations for your cake.',
    newInquiry: 'Send another inquiry',
    cakeTypeLabel: 'What kind of cake are you looking for?',
    types: {
      wedding: 'Wedding cake',
      confirmation: 'Confirmation / celebration cake',
      birthday: 'Birthday cake',
      christening: 'Christening cake',
      company: 'Corporate cake',
      other: 'Other custom cake',
    },
    dateLabel: 'Event date',
    nameLabel: 'Your name',
    companyLabel: 'Company name',
    optional: 'optional',
    emailLabel: 'Email address',
    mobileLabel: 'Phone number',
    addressLabel: 'Address',
    postalLabel: 'Postal code',
    cityLabel: 'City',
    countryLabel: 'Country',
    portionsLabel: 'Number of guests / servings',
    spongeLabel: 'Desired cake sponge',
    sponges: [
      'Not decided yet',
      'Classic light vanilla sponge',
      'Moist dark chocolate sponge',
      'Nut / almond sponge',
      'Carrot sponge',
      'Fudgy brownie base',
      'Other (specify in message)',
    ],
    mousseLabel: 'Desired mousse / filling',
    mousses: [
      'Not decided yet',
      'White chocolate mousse with passion fruit',
      'Dark chocolate mousse with raspberry',
      'Milk chocolate mousse with salted caramel',
      'Strawberry / forest berry mousse',
      'Lemon & lime curd cream',
      'Mocha & caramel mousse',
      'Other (specify in message)',
    ],
    extraFillingLabel: 'Extra filling (crunch layer, berry compote, etc.)',
    extraDecoLabel: 'Decoration / Theme (fresh flowers, berries, chocolate art)',
    cakeTextLabel: 'Inscription / text on cake',
    messageLabel: 'Describe your wishes & dietary requirements (allergies, etc.)',
    messagePlaceholder:
      'Tell us about colours, style, theme, delivery or pickup on Fanø...',
    submitBtn: 'Send cake inquiry',
    submittingBtn: 'Sending inquiry...',
    requiredErr: 'Please fill in your name and email address.',
    genericErr: 'An error occurred while submitting. Please try again.',
    privacyNote:
      'Your personal details help us contact you. We keep your data safe and strictly confidential.',
  },
  de: {
    successTitle: 'Vielen Dank für Ihre Anfrage!',
    successDesc:
      'Wir prüfen Ihre Wünsche sorgfältig und melden uns an Werktagen innerhalb von 24 Stunden mit Details und Vorschlägen.',
    newInquiry: 'Neue Anfrage senden',
    cakeTypeLabel: 'Um welche Art von Torte geht es?',
    types: {
      wedding: 'Hochzeitstorte',
      confirmation: 'Konfirmationstorte',
      birthday: 'Geburtstagstorte',
      christening: 'Tauftorte',
      company: 'Firmentorte',
      other: 'Andere Festtorte',
    },
    dateLabel: 'Datum der Feier',
    nameLabel: 'Ihr Name',
    companyLabel: 'Evtl. Firmenname',
    optional: 'optional',
    emailLabel: 'E-Mail-Adresse',
    mobileLabel: 'Telefonnummer',
    addressLabel: 'Adresse',
    postalLabel: 'Postleitzahl',
    cityLabel: 'Ort',
    countryLabel: 'Land',
    portionsLabel: 'Anzahl Portionen / Personen',
    spongeLabel: 'Gewünschter Tortenboden',
    sponges: [
      'Noch nicht entschieden',
      'Klassischer Vanille-Biskuitboden',
      'Saftiger Schokoladenboden',
      'Nuss- / Mandelboden',
      'Karottenboden',
      'Brownieboden',
      'Anderer (bitte in Nachricht angeben)',
    ],
    mousseLabel: 'Gewünschte Mousse / Füllung',
    mousses: [
      'Noch nicht entschieden',
      'Weiße Schokoladenmousse mit Passionsfrucht',
      'Zartbitterschokoladenmousse mit Himbeere',
      'Vollmilchschokoladenmousse mit Salzkaramell',
      'Erdbeer- / Waldbeerenmousse',
      'Zitronen- & Limettencreme',
      'Mokka- & Karamellmousse',
      'Andere (bitte in Nachricht angeben)',
    ],
    extraFillingLabel: 'Besondere Füllung (Crunch, Beerenkompott usw.)',
    extraDecoLabel: 'Dekoration / Thema (frische Blumen, Beeren, Schokoladenverzierung)',
    cakeTextLabel: 'Gewünschte Beschriftung auf der Torte',
    messageLabel: 'Beschreibung Ihrer Wünsche & Besonderheiten (Allergien etc.)',
    messagePlaceholder:
      'Beschreiben Sie Farben, Stil, Thema sowie Abholung oder Lieferung auf Fanø...',
    submitBtn: 'Tortenanfrage absenden',
    submittingBtn: 'Wird gesendet...',
    requiredErr: 'Bitte füllen Sie Name und E-Mail-Adresse aus.',
    genericErr: 'Beim Absenden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    privacyNote:
      'Ihre personenbezogenen Daten werden vertraulich behandelt und ausschließlich für diese Anfrage genutzt.',
  },
}

export default function CakeInquiryForm({ lang = 'da' }) {
  const t = FORM_I18N[lang] || FORM_I18N.da

  const [formData, setFormData] = useState({
    kagetype: t.types.wedding,
    dato: '',
    navn: '',
    firmanavn: '',
    email: '',
    mobil: '',
    adresse: '',
    postnummer: '',
    by: '',
    land: lang === 'de' ? 'Deutschland' : lang === 'en' ? 'Denmark' : 'Danmark',
    kagebund: t.sponges[0],
    mousse: t.mousses[0],
    ekstra_fyld: '',
    ekstra_dekoration: '',
    kuverter: '25',
    kagetekst: '',
    besked: '',
    website_url: '', // Honeypot
  })

  const [status, setStatus] = useState('idle') // idle | submitting | success | error
  const [errorMessage, setErrorMessage] = useState('')

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (formData.website_url) {
      setStatus('success')
      return
    }

    if (!formData.navn.trim() || !formData.email.trim()) {
      setErrorMessage(t.requiredErr)
      setStatus('error')
      return
    }

    try {
      setStatus('submitting')
      setErrorMessage('')

      const res = await fetch('/_api/webform/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form_name: `Kage forespørgsel (${lang.toUpperCase()})`,
          ...formData,
        }),
      })

      if (!res.ok) {
        throw new Error(t.genericErr)
      }

      setStatus('success')
    } catch (err) {
      setStatus('error')
      setErrorMessage(err.message || t.genericErr)
    }
  }

  if (status === 'success') {
    return (
      <div className="bg-[#F7ECEE] border border-[#C68D94]/30 rounded-3xl p-10 text-center text-[#3E3435] max-w-2xl mx-auto shadow-sm">
        <div className="text-[#A35D67] flex items-center justify-center mx-auto mb-4">
          <i className="fa-solid fa-cake-candles text-4xl" aria-hidden="true" />
        </div>
        <h3 className="font-script text-3xl sm:text-4xl text-[#3E3435] mb-2 font-normal">
          {t.successTitle}
        </h3>
        <p className="text-xs sm:text-sm text-[#3E3435]/80 max-w-md mx-auto leading-relaxed">
          {t.successDesc}
        </p>
        <button
          type="button"
          onClick={() => {
            setStatus('idle')
            setFormData({
              kagetype: t.types.wedding,
              dato: '',
              navn: '',
              firmanavn: '',
              email: '',
              mobil: '',
              adresse: '',
              postnummer: '',
              by: '',
              land: lang === 'de' ? 'Deutschland' : lang === 'en' ? 'Denmark' : 'Danmark',
              kagebund: t.sponges[0],
              mousse: t.mousses[0],
              ekstra_fyld: '',
              ekstra_dekoration: '',
              kuverter: '25',
              kagetekst: '',
              besked: '',
              website_url: '',
            })
          }}
          className="mt-6 inline-block bg-[#C68D94] hover:bg-[#A35D67] text-white text-xs uppercase font-semibold tracking-wider px-7 py-3 rounded-full transition-colors shadow-sm"
        >
          {t.newInquiry}
        </button>
      </div>
    )
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white rounded-3xl p-6 sm:p-10 border border-[#C68D94]/20 shadow-sm space-y-6"
      noValidate
    >
      {/* Honeypot */}
      <input
        type="text"
        name="website_url"
        value={formData.website_url}
        onChange={handleChange}
        className="sr-only absolute -left-[9999px]"
        tabIndex={-1}
        autoComplete="off"
      />

      {/* Row 1: Kagetype & Dato */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label
            htmlFor="inquiry-kagetype"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.cakeTypeLabel}
          </label>
          <select
            id="inquiry-kagetype"
            name="kagetype"
            value={formData.kagetype}
            onChange={handleChange}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all cursor-pointer"
          >
            {Object.entries(t.types).map(([key, label]) => (
              <option key={key} value={label}>
                {label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="inquiry-dato"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.dateLabel}
          </label>
          <input
            id="inquiry-dato"
            type="date"
            name="dato"
            value={formData.dato}
            onChange={handleChange}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>
      </div>

      {/* Row 2: Navn & Firmanavn */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label
            htmlFor="inquiry-navn"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.nameLabel} <span className="text-[#A35D67]">*</span>
          </label>
          <input
            id="inquiry-navn"
            type="text"
            name="navn"
            value={formData.navn}
            onChange={handleChange}
            placeholder={t.nameLabel}
            required
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>

        <div>
          <label
            htmlFor="inquiry-firmanavn"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.companyLabel} <span className="text-stone-400 font-light">({t.optional})</span>
          </label>
          <input
            id="inquiry-firmanavn"
            type="text"
            name="firmanavn"
            value={formData.firmanavn}
            onChange={handleChange}
            placeholder={t.companyLabel}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>
      </div>

      {/* Row 3: Email & Mobil */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label
            htmlFor="inquiry-email"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.emailLabel} <span className="text-[#A35D67]">*</span>
          </label>
          <input
            id="inquiry-email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="din@email.dk"
            required
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>

        <div>
          <label
            htmlFor="inquiry-mobil"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.mobileLabel}
          </label>
          <input
            id="inquiry-mobil"
            type="tel"
            name="mobil"
            value={formData.mobil}
            onChange={handleChange}
            placeholder="60 22 47 04"
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>
      </div>

      {/* Row 4: Adresse, Postnr & By */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        <div className="sm:col-span-1">
          <label
            htmlFor="inquiry-adresse"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.addressLabel}
          </label>
          <input
            id="inquiry-adresse"
            type="text"
            name="adresse"
            value={formData.adresse}
            onChange={handleChange}
            placeholder="Vejnavn 1"
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>

        <div>
          <label
            htmlFor="inquiry-postnummer"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.postalLabel}
          </label>
          <input
            id="inquiry-postnummer"
            type="text"
            name="postnummer"
            value={formData.postnummer}
            onChange={handleChange}
            placeholder="6720"
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>

        <div>
          <label
            htmlFor="inquiry-by"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.cityLabel}
          </label>
          <input
            id="inquiry-by"
            type="text"
            name="by"
            value={formData.by}
            onChange={handleChange}
            placeholder="Fanø"
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>
      </div>

      {/* Row 5: Kuverter, Kagebund & Mousse */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 pt-2 border-t border-[#C68D94]/15">
        <div>
          <label
            htmlFor="inquiry-kuverter"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.portionsLabel}
          </label>
          <input
            id="inquiry-kuverter"
            type="number"
            min="10"
            max="300"
            name="kuverter"
            value={formData.kuverter}
            onChange={handleChange}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>

        <div>
          <label
            htmlFor="inquiry-kagebund"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.spongeLabel}
          </label>
          <select
            id="inquiry-kagebund"
            name="kagebund"
            value={formData.kagebund}
            onChange={handleChange}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all cursor-pointer"
          >
            {t.sponges.map((s, idx) => (
              <option key={idx} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="inquiry-mousse"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.mousseLabel}
          </label>
          <select
            id="inquiry-mousse"
            name="mousse"
            value={formData.mousse}
            onChange={handleChange}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all cursor-pointer"
          >
            {t.mousses.map((m, idx) => (
              <option key={idx} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Row 6: Ekstra Fyld & Dekoration */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label
            htmlFor="inquiry-ekstra-fyld"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.extraFillingLabel}
          </label>
          <input
            id="inquiry-ekstra-fyld"
            type="text"
            name="ekstra_fyld"
            value={formData.ekstra_fyld}
            onChange={handleChange}
            placeholder={t.extraFillingLabel}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>

        <div>
          <label
            htmlFor="inquiry-ekstra-dekoration"
            className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
          >
            {t.extraDecoLabel}
          </label>
          <input
            id="inquiry-ekstra-dekoration"
            type="text"
            name="ekstra_dekoration"
            value={formData.ekstra_dekoration}
            onChange={handleChange}
            placeholder={t.extraDecoLabel}
            className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
          />
        </div>
      </div>

      {/* Row 7: Kagetekst & Besked */}
      <div>
        <label
          htmlFor="inquiry-kagetekst"
          className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
        >
          {t.cakeTextLabel}
        </label>
        <input
          id="inquiry-kagetekst"
          type="text"
          name="kagetekst"
          value={formData.kagetekst}
          onChange={handleChange}
          placeholder={t.cakeTextLabel}
          className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all"
        />
      </div>

      <div>
        <label
          htmlFor="inquiry-besked"
          className="block text-xs font-semibold uppercase tracking-wider text-[#3E3435] mb-1.5"
        >
          {t.messageLabel}
        </label>
        <textarea
          id="inquiry-besked"
          name="besked"
          rows={4}
          value={formData.besked}
          onChange={handleChange}
          placeholder={t.messagePlaceholder}
          className="w-full bg-[#FDF8F7] border border-[#C68D94]/25 rounded-xl px-4 py-3 text-xs sm:text-sm text-[#3E3435] placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#A35D67] focus:bg-white transition-all resize-y"
        />
      </div>

      {errorMessage && (
        <div className="bg-red-50 text-red-700 p-3 rounded-xl text-xs border border-red-200 flex items-center gap-2">
          <i className="fa-solid fa-circle-exclamation shrink-0" aria-hidden="true" />
          <span>{errorMessage}</span>
        </div>
      )}

      <div className="pt-3">
        <button
          type="submit"
          disabled={status === 'submitting'}
          className="w-full sm:w-auto bg-[#C68D94] hover:bg-[#A35D67] text-white px-9 py-3.5 rounded-full text-xs font-semibold tracking-wider uppercase transition-all shadow-sm hover:shadow disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer"
        >
          {status === 'submitting' ? (
            <>
              <i className="fa-solid fa-spinner fa-spin" aria-hidden="true" />
              <span>{t.submittingBtn}</span>
            </>
          ) : (
            <span>{t.submitBtn}</span>
          )}
        </button>
      </div>

      <p className="text-[11px] text-[#3E3435]/60 mt-3 font-light">
        {t.privacyNote}
      </p>
    </form>
  )
}
